import { useState } from "react";
import api, { formatErr } from "@/lib/api";
import { Send, X } from "lucide-react";

export default function EnquiryModal({ onClose }) {
  const [form, setForm] = useState({ company_name: "", name: "", email: "", phone: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/leads", form);
      setDone(true);
    } catch (e) { setErr(formatErr(e.response?.data?.detail) || "Something went wrong"); }
    finally { setBusy(false); }
  };

  return (
    <div className="vb-modal-bg" onClick={onClose} data-testid="enquiry-modal">
      <div className="vb-modal" style={{ maxWidth: 540 }} onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between mb-1">
          <h2 className="m-0">Enquire about Vanguard Beacon</h2>
          <button onClick={onClose} className="vb-link" data-testid="enquiry-close"><X size={18} /></button>
        </div>
        <p className="text-sm opacity-75 mb-5">Tell us a bit about your operation and our team will reach out with a tailored proposal — typically within 1 business day.</p>

        {done ? (
          <div className="text-center py-6" data-testid="enquiry-done">
            <div className="vb-pill ok inline-flex mb-3">✓ Enquiry received</div>
            <p>Thank you. Our team will reach out to <strong>{form.email}</strong> shortly.</p>
            <button className="vb-btn mt-5" onClick={onClose}>Close</button>
          </div>
        ) : (
          <form onSubmit={submit} className="grid gap-3">
            {err && <div className="vb-pill err">{err}</div>}
            <div className="grid sm:grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-semibold mb-1.5 uppercase tracking-wider" style={{ color: "var(--vb-text-2)" }}>Company name *</label>
                <input className="vb-input" required value={form.company_name} onChange={upd("company_name")} data-testid="enq-company" />
              </div>
              <div>
                <label className="block text-xs font-semibold mb-1.5 uppercase tracking-wider" style={{ color: "var(--vb-text-2)" }}>Your name *</label>
                <input className="vb-input" required value={form.name} onChange={upd("name")} data-testid="enq-name" />
              </div>
            </div>
            <div className="grid sm:grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-semibold mb-1.5 uppercase tracking-wider" style={{ color: "var(--vb-text-2)" }}>Email *</label>
                <input className="vb-input" required type="email" value={form.email} onChange={upd("email")} data-testid="enq-email" />
              </div>
              <div>
                <label className="block text-xs font-semibold mb-1.5 uppercase tracking-wider" style={{ color: "var(--vb-text-2)" }}>Contact number</label>
                <input className="vb-input" value={form.phone} onChange={upd("phone")} placeholder="+65 ..." data-testid="enq-phone" />
              </div>
            </div>
            <div>
              <label className="block text-xs font-semibold mb-1.5 uppercase tracking-wider" style={{ color: "var(--vb-text-2)" }}>Tell us about your needs *</label>
              <textarea className="vb-input" rows={4} required value={form.message} onChange={upd("message")} placeholder="Number of sites, key compliance challenges, target timeline…" data-testid="enq-message" />
            </div>
            <div className="flex gap-2 justify-end mt-2">
              <button type="button" className="vb-btn ghost" onClick={onClose}>Cancel</button>
              <button type="submit" className="vb-btn" disabled={busy} data-testid="enq-submit">
                <Send size={14} /> {busy ? "Sending…" : "Send enquiry"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
